import React from 'react';
import MaterialButton, { ButtonProps } from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  progress: {
    color: 'white',
  },
  progressBox: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hide: {
    visibility: 'hidden',
  },
}));

interface ButtonPropsExtended extends ButtonProps {
  children: any;
  isLoading?: boolean;
  component?: string;
}

const Button = ({ children, isLoading, ...rest }: ButtonPropsExtended) => {
  const classes = useStyles(rest);

  return (
    <MaterialButton {...rest}>
      {isLoading && (
        <span className={classes.progressBox}>
          <CircularProgress className={classes.progress} size={24} />
        </span>
      )}
      <span className={isLoading ? classes.hide : undefined}>{children}</span>
    </MaterialButton>
  );
};

export default Button;
